/**
 *
 * EmbeddedPage
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { useScreenDetector } from '../../components/custom-hooks/screen-detector';
import injectReducer from '../../utils/injectReducer';
import injectSaga from '../../utils/injectSaga';
import makeSelectEmbeddedPage from './selectors';
import reducer from './reducer';
import saga from './saga';
import Embedded from '../../components/Embedded';
import { getIsProductAddonsSelected } from '../../components/helpers/offer';
import { setIsProductAddonsAboveATCRendered } from '../actions';
import {
  addToCart,
  addToCartSuccess,
  addVariantIdsOfProductsToHide,
  balanceProductAddtions,
  sendEvent,
} from '../Init/actions';
import {
  updateSelectedCheckboxProducts,
  updateEmbeddedOfferTheme,
  updateEmbeddedMrOfferID,
  updatePrimaryProduct,
  updateProductAddOnsWidgetID,
  updateField as updateFieldAction,
} from './actions';
import makeSelectInit from '../Init/selectors';
import {
  _compareCartAndAddProductAdditions,
  _getAddedVariantTitleFromCart,
  _getProductAddtionsByProductIndex,
  _getTotalQuantity,
  _getVariantQuantity,
  _getVariantQuantityFromCart,
  _isMaximumProductsAdded,
  _isCurrProductSelectedInRestrictedOfferedProducts,
  _isOfferedProductsRestrictedAndAdded,
  _onAddClick,
  _getOptions,
  _getProductQuantity,
  _getLastAddedVariant,
  _getLastAddition,
  _getProductIDFromVariantID,
  _productEvent,
  _getAddedVariantsToDisplay,
  _isPrimaryAndOfferedSame,
  _getProductFromVariantID,
} from '../../../productHelper';

import { calculateDiscount } from '../../components/helpers/discount';
import {
  addOfferedVariantsToCart,
  getBundleOrAddonOrFBTVariantsToAdd,
  getMonkDiscountProperties,
  _isVariantPresentInCart,
} from '../../../common/cart';
import { getShop } from '../../../common/pageData';
import { goToCart, goToProductPage } from '../../../common/navigation';
import { productAddonLayouts } from '../../../common/constants';
import { getEventConstants } from '../../../eventsHelper';

function EmbeddedPage(props) {
  const {
    addToCart,
    init: {
      productAdditions: additionsBasedOnWidgetID,
      variantIDsOfProductsToHide,
      atcStatus,
    },
    embeddedPage: { selectedCheckboxProducts },
    balanceProductAddtions,
    sendEvent,
    addToCartSuccessEvent,
    products,
    theme,
    widgetID,
    updateProductAddOnsWidgetID,
    updateField,
    discountQuantity,
    offerLevelDiscountQuantityFromOffer,
    isConsiderRepetetionOfRules,
  } = props;
  const productAdditions = additionsBasedOnWidgetID[widgetID] || [];

  const { isMobile } = useScreenDetector();

  const getProductAdditionsOfOffer = () =>
    productAdditions.filter(addition => {
      for (let i = 0; i < products.length; i += 1) {
        for (let j = 0; j < products[i].variants.length; j += 1) {
          if (products[i].variants[j].id === addition.variant_id) {
            return true;
          }
        }
      }
      return false;
    });

  const calculateDiscountEmbedded = (
    price,
    compareAtPrice,
    offText,
    taxes = 0,
    shipping = 0,
    discountValue = 0,
    isDiscountDisabled = false,
  ) =>
    calculateDiscount({
      price,
      compareAtPrice,
      offText,
      taxes,
      shipping,
      discountValue,
      isDiscountDisabled,
      discountType: props.discountType,
      currencyFormat: props.currencyFormat,
      decimalSymbol: props.decimalSymbol,
      thousandSeparator: props.thousandSeparator,
      productDiscountText: theme.productDiscountText,
      currencySymbol: props.currencySymbol,
      isApplyDiscountOnCompareAtPrice: props.isApplyDiscountOnCompareAtPrice,
      priceRoundType: props.priceRoundType,
      discountRoundType: props.discountRoundType,
    });

  // as there can be multiple widgets, maintain below atc state for each widget
  const [belowATCCheckboxProducts, setBelowATCCheckboxProducts] = useState([]);

  const setSelectedCheckboxProducts = newSelectedCheckboxProducts => {
    if (isAboveATCProductAddons()) {
      props.updateSelectedCheckboxProducts({ newSelectedCheckboxProducts });
      return;
    }
    setBelowATCCheckboxProducts(newSelectedCheckboxProducts);
  };

  const getSelectedCheckboxProducts = () => {
    if (isAboveATCProductAddons()) {
      return selectedCheckboxProducts;
    }
    return belowATCCheckboxProducts;
  };

  const isAboveATCProductAddons = () => {
    if (
      getIsProductAddonsSelected({
        offerType: props.offerType,
        mobileLayoutType: theme.mobileLayoutType,
        desktopLayoutType: theme.desktopLayoutType,
        isMobile,
        productAddonLayouts,
      })
    ) {
      if (theme.widgetPosition === 'above_atc') {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    updateField({
      name: 'isConsiderRepetetionOfRules',
      v: isConsiderRepetetionOfRules,
    });
    if (
      getIsProductAddonsSelected({
        offerType: props.offerType,
        mobileLayoutType: theme.mobileLayoutType,
        desktopLayoutType: theme.desktopLayoutType,
        isMobile,
        productAddonLayouts,
      })
    ) {
      if (theme.widgetPosition === 'above_atc') {
        props.setIsProductAddonsAboveATCRendered(true);
        updateProductAddOnsWidgetID({ widgetID });
        updateField({
          name: 'discountQuantity',
          v: discountQuantity,
        });
        updateField({
          name: 'offerLevelDiscountQuantity',
          v: offerLevelDiscountQuantityFromOffer,
        });
      }

      if (
        (theme.mobileLayoutType === 'checkbox' && isMobile) ||
        (theme.desktopLayoutType === 'checkbox' && !isMobile)
      ) {
        const productsSelectedAsAddons = products
          .map((product, i) => ({ ...product, originalIndex: i }))
          .filter(product => product.isPreselectedAsAddons);

        const newSelectedCheckboxProducts = productsSelectedAsAddons.map(
          product => ({
            ...product,
            variants: [product.variants[0]],
          }),
        );
        setSelectedCheckboxProducts(newSelectedCheckboxProducts);
      }
    }
    props.updateEmbeddedMrOfferID({ updatedMrOfferID: props.mrOfferID });
    props.updatePrimaryProduct({
      updatedPrimaryProduct: props.primary,
    });
    props.updateEmbeddedOfferTheme({ updatedTheme: theme });

    return () => props.setIsProductAddonsAboveATCRendered(false);
  }, []);

  const getIsConsiderReservedItemQuantity = () => {
    const { offerType } = props;
    const offersWithReservedItemQty = ['freegift', 'crossell'];
    if (offersWithReservedItemQty.includes(offerType)) {
      return true;
    }
    return false;
  };

  return (
    <Embedded
      isConsiderReservedQuantity={getIsConsiderReservedItemQuantity()}
      reservedItemQuantity={props.reservedItemQuantity}
      isRepeatRules={props.isRepeatRules}
      mrOfferID={props.mrOfferID}
      products={products}
      primary={props.primary}
      theme={theme}
      cart={props.cart}
      fetchCart={props.fetchCart}
      isTimerDisabled={props.isTimerDisabled}
      isDiscountDisabled={props.isDiscountDisabled}
      triggerType={props.triggerType}
      offerType={props.offerType}
      currencyFormat={props.currencyFormat}
      currencySymbol={props.currencySymbol}
      decimalSymbol={props.decimalSymbol}
      thousandSeparator={props.thousandSeparator}
      discountType={props.discountType}
      discountValue={props.discountValue}
      discountQuantity={props.discountQuantity}
      isDiscountQuantityRestricted={props.isDiscountQuantityRestricted}
      isNumberOfOfferedProductsRestricted={
        props.isNumberOfOfferedProductsRestricted
      }
      isHideAfterProductAddition={props.isHideAfterProductAddition}
      changeCartVartiantWithoutProperties={
        props.changeCartVartiantWithoutProperties
      }
      variantsWithQuantity={props.variantsWithQuantity}
      addToCart={addToCart}
      productAdditions={getProductAdditionsOfOffer()}
      balanceProductAddtions={balanceProductAddtions}
      _compareCartAndAddProductAdditions={_compareCartAndAddProductAdditions}
      _getAddedVariantTitleFromCart={_getAddedVariantTitleFromCart}
      _getProductAddtionsByProductIndex={_getProductAddtionsByProductIndex}
      _getTotalQuantity={_getTotalQuantity}
      _getVariantQuantity={_getVariantQuantity}
      _getVariantQuantityFromCart={_getVariantQuantityFromCart}
      _isMaximumProductsAdded={_isMaximumProductsAdded}
      _isCurrProductSelectedInRestrictedOfferedProducts={
        _isCurrProductSelectedInRestrictedOfferedProducts
      }
      _isOfferedProductsRestrictedAndAdded={
        _isOfferedProductsRestrictedAndAdded
      }
      getMonkDiscountProperties={getMonkDiscountProperties}
      _onAddClick={_onAddClick}
      _getOptions={_getOptions}
      _getProductQuantity={_getProductQuantity}
      _getLastAddedVariant={_getLastAddedVariant}
      _getLastAddition={_getLastAddition}
      goToProductPage={
        getShop() === 'hornskov-kobenhavn.myshopify.com'
          ? () => {}
          : goToProductPage
      }
      calculateDiscountAdmin={calculateDiscountEmbedded}
      offTextAdmin=""
      _getProductIDFromVariantID={_getProductIDFromVariantID}
      _getProductFromVariantID={_getProductFromVariantID}
      sendEvent={sendEvent}
      _productEvent={_productEvent}
      eventConstants={getEventConstants()}
      _getAddedVariantsToDisplay={_getAddedVariantsToDisplay}
      _isVariantPresentInCart={_isVariantPresentInCart}
      shopURL={getShop()}
      _isPrimaryAndOfferedSame={_isPrimaryAndOfferedSame}
      isBrandingEnabled={props.isBrandingEnabled}
      _getBundleOrAddonOrFBTVariantsToAdd={getBundleOrAddonOrFBTVariantsToAdd}
      addOfferedVariantsToCart={addOfferedVariantsToCart}
      goToCart={goToCart}
      fbtDiscountValue={props.fbtDiscountValue}
      fbtPartialDiscountValue={props.fbtPartialDiscountValue}
      isFBTDiscountDisabled={props.isFBTDiscountDisabled}
      isFBTPartialDiscountDisabled={props.isFBTPartialDiscountDisabled}
      addToCartSuccessEvent={addToCartSuccessEvent}
      addVariantIdsOfProductsToHide={props.addVariantIdsOfProductsToHide}
      variantIDsOfProductsToHide={variantIDsOfProductsToHide}
      priceRoundType={props.priceRoundType}
      discountRoundType={props.discountRoundType}
      selectedCheckboxProducts={getSelectedCheckboxProducts()}
      setSelectedCheckboxProducts={setSelectedCheckboxProducts}
      addProductAddonsToCart={props.addProductAddonsToCart}
      dispatch={props.dispatch}
      productAddonLayouts={productAddonLayouts}
      offerLevelDiscountQuantity={props.offerLevelDiscountQuantityToUse}
      atcStatus={atcStatus}
      widgetID={widgetID}
      updateField={updateField}
    />
  );
}

EmbeddedPage.propTypes = {
  reservedItemQuantity: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  // props: PropTypes.object.isRequired,
  mrOfferID: PropTypes.string,
  theme: PropTypes.object,
  products: PropTypes.array,
  primary: PropTypes.object,
  cart: PropTypes.any,
  fetchCart: PropTypes.func,
  isTimerDisabled: PropTypes.bool,
  triggerType: PropTypes.string,
  isDiscountDisabled: PropTypes.bool,
  offerType: PropTypes.string,
  discountValue: PropTypes.number,
  discountType: PropTypes.string,
  discountQuantity: PropTypes.number,
  isBrandingEnabled: PropTypes.bool,
  currencyFormat: PropTypes.string,
  currencySymbol: PropTypes.string,
  decimalSymbol: PropTypes.string,
  thousandSeparator: PropTypes.string,
  isDiscountQuantityRestricted: PropTypes.bool,
  isNumberOfOfferedProductsRestricted: PropTypes.bool,
  isHideAfterProductAddition: PropTypes.func,
  changeCartVartiantWithoutProperties: PropTypes.func,
  variantsWithQuantity: PropTypes.array,
  fbtDiscountValue: PropTypes.number,
  fbtPartialDiscountValue: PropTypes.number,
  isFBTDiscountDisabled: PropTypes.bool,
  isFBTPartialDiscountDisabled: PropTypes.bool,
  addVariantIdsOfProductsToHide: PropTypes.func,
  updateSelectedCheckboxProducts: PropTypes.func,
  updateEmbeddedOfferTheme: PropTypes.func,
  addToCart: PropTypes.func,
  init: PropTypes.object,
  embeddedPage: PropTypes.object,
  balanceProductAddtions: PropTypes.func,
  sendEvent: PropTypes.func,
  addToCartSuccessEvent: PropTypes.func,
  isApplyDiscountOnCompareAtPrice: PropTypes.bool,
  priceRoundType: PropTypes.string,
  discountRoundType: PropTypes.string,
  addProductAddonsToCart: PropTypes.func,
  updateEmbeddedMrOfferID: PropTypes.func,
  updatePrimaryProduct: PropTypes.func,
  setIsProductAddonsAboveATCRendered: PropTypes.func,
  offerLevelDiscountQuantityToUse: PropTypes.number,
  offerLevelDiscountQuantityFromOffer: PropTypes.number,
  isRepeatRules: PropTypes.bool,
  updateField: PropTypes.func,
  isConsiderRepetetionOfRules: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  embeddedPage: makeSelectEmbeddedPage(),
  init: makeSelectInit(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    addToCart: datapack => {
      dispatch(addToCart(datapack));
    },
    balanceProductAddtions: datapack => {
      dispatch(balanceProductAddtions(datapack));
    },

    sendEvent: datapack => {
      dispatch(sendEvent(datapack));
    },
    addToCartSuccessEvent: datapack => {
      dispatch(addToCartSuccess(datapack));
    },

    addVariantIdsOfProductsToHide: datapack => {
      dispatch(addVariantIdsOfProductsToHide(datapack));
    },

    updateSelectedCheckboxProducts: datapack => {
      dispatch(updateSelectedCheckboxProducts(datapack));
    },
    updateEmbeddedOfferTheme: datapack => {
      dispatch(updateEmbeddedOfferTheme(datapack));
    },
    updateEmbeddedMrOfferID: datapack => {
      dispatch(updateEmbeddedMrOfferID(datapack));
    },
    updatePrimaryProduct: datapack => {
      dispatch(updatePrimaryProduct(datapack));
    },
    setIsProductAddonsAboveATCRendered: datapack => {
      dispatch(
        setIsProductAddonsAboveATCRendered({
          isProductAddonsAboveATCRendered: datapack,
        }),
      );
    },
    updateProductAddOnsWidgetID: datapack => {
      dispatch(updateProductAddOnsWidgetID(datapack));
    },
    updateField: datapack => {
      dispatch(updateFieldAction(datapack));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'embeddedPage', reducer });
const withSaga = injectSaga({ key: 'embeddedPage', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(EmbeddedPage);
